import React from 'react'
import { Button } from '../../../components'

const GuestRow = ({translate, guest, onClick}) => {
  console.log({guest})
  return (
    <div className="flex flex-wrap -mx-4 mb-8">
      <div className="w-full lg:w-2/3 px-4 mb-5 lg:mb-0">
        <p className="font-bold text-xs">{translate('EVENT', 'order_no')}</p>
        <p className="text-gray-444 text-sm mb-5">{guest.order_number}</p>
        <div className="flex flex-wrap -mx-4 mb-5">
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">{translate('GENERAL', 'name')}</p>
            <p className="text-gray-444 text-sm">{guest.name}</p>
          </div>
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">{translate('GENERAL', 'occupation')}</p>
            <p className="text-gray-444 text-sm">{guest.occupation}</p>
          </div>
        </div>
        <div className="flex flex-wrap -mx-4 mb-5">
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">{translate('AUTH', 'email')}</p>
            <p className="text-gray-444 text-sm break-words">{guest.email}</p>
          </div>
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">{translate('GENERAL', 'phone')}</p>
            <p className="text-gray-444 text-sm">{guest.phone}</p>
          </div>
        </div>
        <div className="flex flex-wrap -mx-4 mb-5">
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">{translate('GENERAL', 'disability_status')}</p>
            <p className="text-gray-444 text-sm break-words">{guest.disability_status}</p>
          </div>
          <div className="w-1/2 px-4">
            <p className="font-bold text-xs">{translate('GENERAL', 'gender')}</p>
            <p className="text-gray-444 text-sm">{guest.gender}</p>
          </div>
        </div>
      </div>
      <div className="w-full lg:w-1/3 px-4">
        <Button thin onClick={onClick}>
          {translate('EVENT', 'see_ticket')}
        </Button>
      </div>
    </div>
  )
}

export default GuestRow
